export const getMonthOptions = (
  monthsMap: { value: number; label: string }[],
  query?: string
) => {
  if (!query) return monthsMap;

  const lowerQuery = query.toLowerCase();

  return monthsMap.filter((m) => {
    const labelMatch = m.label.toLowerCase().startsWith(lowerQuery);
    const valueStr = m.value.toString();
    const paddedValueStr = valueStr.padStart(2, "0");
    const valueMatch =
      valueStr.startsWith(lowerQuery) || paddedValueStr.startsWith(lowerQuery);

    return labelMatch || valueMatch;
  });
};

export const getDayOptions = (maxDay: number, query?: string) => {
  const allDays = Array.from({ length: maxDay }, (_, i) => ({
    value: i + 1,
    label: String(i + 1).padStart(2, "0"),
  }));

  if (!query) return allDays;

  if (!/^\d+$/.test(query)) {
    return [];
  }

  const num = parseInt(query, 10);
  if (num < 1 || num > maxDay) {
    return [];
  }

  return allDays.filter((d) => d.value === num);
};

export const getLowerYearLimit = (): number => {
  const currentYear = new Date().getFullYear();
  const base = currentYear - 120;
  return base - (base % 25);
};
